import "./PediatricianDashboard.css";
import { useEffect, useState } from "react";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import { useDoctorContext } from "../context/DoctorContext";
import PatientsList from "./ui/PatientsList";

const PediatricianDashboard = ({ currentUser }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const{ totalPatients, filterPatients, followupdateRecords, dashboardLoading,validateDashboard,referredPatientsList } = useDoctorContext();
  const navigate = useNavigate();

  const handlePatientNavigate = (patient) => {
    navigate(
      `/new-patient-profile/${patient.patient_id}/${currentUser?.pediatrician_id}`
    );
  };

  console.log(referredPatientsList,'ref patients');
  useEffect(() => {
    validateDashboard(currentUser)
  }, [currentUser]);

  return (
    <div className="doc-dashboard">
      <Loader isLoading={dashboardLoading} />
      <div className="doc-dashboardContainer">
        <h2>Dashboard</h2>
        <div className="total-patients">
          <div className="animation-dashboard">
          <p>Your Id: {currentUser?.pediatrician_id}</p>
        </div>
          <p>
            Total Patients: <b>{totalPatients}</b>
          </p>
        </div>
          <PatientsList filterPatients={filterPatients} action={handlePatientNavigate} searchTerm={searchTerm} setSearchTerm={setSearchTerm} actionLabel={'Go to profile'}/>
          <PatientsList filterPatients={referredPatientsList} action={handlePatientNavigate} searchTerm={searchTerm} setSearchTerm={setSearchTerm} actionLabel={'Go to profile'} heading={'Referred Patients'}/>
        <div className="doc-patient-container appointment">
          <p>Upcoming Appointments</p>
          <div className="doc-patient-grid-container appointment-grid-container">
            <div className="doc-appointment-grid doc-grid-heading">
              <p>Date</p>
              <p>Caregiver FN</p>
              <p>Caregiver LN</p>
              <p>Patient FN</p>
              <p>Patient LN</p>
              <p>Phone</p>
            </div>
            {followupdateRecords.map(({ heading, records }, i) => (
              <div
                key={heading}
                className={`${
                  i === followupdateRecords.length - 1
                    ? "appointment-last-record"
                    : "doc-appointment-list"
                }`}
              >
                {records.map((data, i) => (
                  <div
                    key={i}
                    className={"doc-appointment-grid appointment-grid"}
                  >
                    {i === 0 ? (
                      <p
                        style={{
                          gridRow: `span ${records.length}`,
                          alignSelf: "center",
                        }}
                      >
                        {heading}
                      </p>
                    ) : (
                      <p style={{ visibility: "hidden" }}></p>
                    )}

                    <p translate="no">{data.caregiver.first_name}</p>
                    <p translate="no">{data.caregiver.last_name}</p>
                    <p translate="no">{data.patient_info.first_name}</p>
                    <p translate="no">{data.patient_info.last_name}</p>
                    <p translate="no">{data.caregiver.phone_number}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {followupdateRecords.length === 0 && (
            <p>No Upcoming Appointments (7 Days)</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default PediatricianDashboard;
